import { Validator } from 'fluentvalidation-ts';
import { beBetweenInclusive, haveDecimalPlaces } from '../../../../../validators/stringValidators';

export type UnitWallElementFormModel = {
  wallElementId: number | null;
  name: string;
  wallThermalTransmittance: string;
  windowThermalTransmittance: string;
  doorThermalTransmittance: string;
  defaultExternalAirTemperatureInDegreesCelsius: string;
};

export const getDefaultUnitWallElementFormModel = (
  defaultExternalAirTemperatureInDegreesCelsius: number | string,
): UnitWallElementFormModel => ({
  wallElementId: null,
  name: 'Wall Element 1',
  wallThermalTransmittance: '',
  windowThermalTransmittance: '',
  doorThermalTransmittance: '',
  defaultExternalAirTemperatureInDegreesCelsius: defaultExternalAirTemperatureInDegreesCelsius.toString(),
});

export class UnitWallElementFormModelValidator extends Validator<UnitWallElementFormModel> {
  constructor(heatLossIsRequired: boolean) {
    super();

    this.ruleFor('name')
      .notEmpty()
      .maxLength(100);

    this.ruleFor('wallThermalTransmittance')
      .must(beBetweenInclusive(0, 99999999))
      .must(haveDecimalPlaces(3));

    this.ruleFor('wallThermalTransmittance')
      .notEmpty()
      .when(() => heatLossIsRequired);

    this.ruleFor('windowThermalTransmittance')
      .must(beBetweenInclusive(0, 99999999))
      .must(haveDecimalPlaces(3));

    this.ruleFor('windowThermalTransmittance')
      .notEmpty()
      .when(() => heatLossIsRequired);

    this.ruleFor('doorThermalTransmittance')
      .must(beBetweenInclusive(0, 99999999))
      .must(haveDecimalPlaces(3));

    this.ruleFor('doorThermalTransmittance')
      .notEmpty()
      .when(() => heatLossIsRequired);

    this.ruleFor('defaultExternalAirTemperatureInDegreesCelsius').must(haveDecimalPlaces(1));

    this.ruleFor('defaultExternalAirTemperatureInDegreesCelsius')
      .notEmpty()
      .when(() => heatLossIsRequired);
  }
}
